<script setup lang="ts">
import { computed, useTemplateRef, type InputHTMLAttributes } from 'vue';
import type { BaseTextInputProps } from './internal';
import NxInput from './NxInput.vue';

const props = defineProps<
  BaseTextInputProps & {
    pattern: string;
    onInput?: (payload: InputEvent) => void;
  } & /* @vue-ignore */ Omit<InputHTMLAttributes, 'pattern' | 'onInput'>
>();
const [valueModel, valueModelModifiers] = defineModel<string, 'lazy'>({ required: true });

function validate(e: InputEvent) {
  const target = e.target as HTMLInputElement;
  const prevVal = target.value;
  target.addEventListener(
    'input',
    (payload: Event) => {
      if (target.validity.patternMismatch) {
        target.value = prevVal;
        valueModel.value = prevVal;
        return;
      }
      props.onInput?.(payload as InputEvent);
    },
    { once: true }
  );
}

const inputRef = useTemplateRef('nx-input-element');
const exposeRef = computed(() => {
  return inputRef.value?.inputElement;
});
defineExpose({
  inputElement: exposeRef,
});
</script>

<template>
  <NxInput
    v-if="valueModelModifiers.lazy"
    v-bind="{
      ...props,
      ...$attrs,
      type: 'text',
      onInput: undefined,
    }"
    ref="nx-input-element"
    v-model.lazy="valueModel"
    @beforeinput="validate"
  />
  <NxInput
    v-else
    v-bind="{
      ...props,
      ...$attrs,
      type: 'text',
      onInput: undefined,
    }"
    ref="nx-input-element"
    v-model="valueModel"
    @beforeinput="validate"
  />
</template>
